export default __webpack_public_path__ + "static/media/inventory.4a4f39a0.svg";